import { useEffect, useState } from "react";
import { addOnChangeHook, deleteOnChangeHook } from "../../BackgroundPoller";
import { FoodMenuWidgetInterface, WidgetInterface } from "../../types";


interface MenuOption {
    title_fi: string;
    title_en: string;
}

interface Props {
    widget  : WidgetInterface;
    editable : boolean;
    onUpdate: (id: string, updates: Partial<WidgetInterface>) => void;
}

function defaultFoodMenuWidgetInterface() : FoodMenuWidgetInterface {
  return {type: 0}
}

const types_fi = ["Linjaston ruokalista","Grillin ruokalista","Vegelinjaston ruokalista"]
const types_en = ["Lunch line menu","Grill menu","Vegetarian menu"]

export default function FoodWidget(props : Props) {
    const [homecooked, setHomecooked] = useState<MenuOption[]>([])
    const [vege, setVege] = useState<MenuOption[]>([])
    const [grill, setGrill] = useState<MenuOption[]>([])

    const ts : FoodMenuWidgetInterface = props.widget.data ? props.widget.data : defaultFoodMenuWidgetInterface();
    

    const changeMealType = () => {
        props.onUpdate(props.widget.id, {
          data: {type:(ts.type+1) % 3}
        });
    }

    useEffect(() => {
        let hook = (data) => {
            let t = new Date();
            let th = t.getHours() + t.getMinutes() / 60;
            try {
                let courses = data["food"]["courses"]
                let homecooked : MenuOption[] = []
                let vege : MenuOption[] = []
                let grill : MenuOption[] = []
                //console.log(courses)
                for (let i in courses) {
                    if (courses[i]["category"].match(/favorites/gi)) {
                        let v : MenuOption  = {"title_fi" : courses[i]["title_fi"], "title_en" : courses[i]["title_en"]}
                        homecooked.push(v)
                    } else if (courses[i]["category"].match(/grill/gi) || courses[i]["category"].match(/oven/gi) || courses[i]["category"].match(/kitchen vegan/gi)) {
                        let v : MenuOption  = {"title_fi" : courses[i]["title_fi"], "title_en" : courses[i]["title_en"]}
                        grill.push(v)
                    } else if (courses[i]["category"].match(/veg/gi) || courses[i]["category"].match(/soup/gi) || courses[i]["category"].match(/sala/gi)) {
                        let v : MenuOption  = {"title_fi" : courses[i]["title_fi"], "title_en" : courses[i]["title_en"]}
                        vege.push(v)
                    }
                    
                }
                setHomecooked(homecooked)
                setVege(vege)
                setGrill(grill)
            } catch (e) {console.log(e)}
        };
        addOnChangeHook(hook)
        return () => {deleteOnChangeHook(hook)}
    })

    const t : MenuOption[] = (ts.type == 2 ? vege : (ts.type == 1 ? grill : homecooked))

    return (
    <div style={{lineHeight: "2em"}}>
        <h2 style={{"cursor" : props.editable ? "pointer" : "default"}} onClick={() => { props.editable ? changeMealType() : ""}}>{types_fi[ts.type]}</h2>
        <h3 style={{"cursor" : props.editable ? "pointer" : "default"}} onClick={() => { props.editable ? changeMealType() : ""}}>{types_en[ts.type]}</h3>
        <div style={{padding: "6px"}} />
            <div style={{marginLeft: "12px"}}>
                { 
                t.length ? t.map( v => ( <p key={v.title_fi}><b style={{fontSize: "18px"}}>{v.title_fi}</b><br/><i>{v.title_en}</i></p>)) : (<p><b>Ladataan ruokalistaa...</b><br/><i>Loading menu...</i></p>) 
                }
            </div>
        </div>
    )
}